import type { NotificationOutcome } from '@enterprise/api';
import { ArrowsRotate, Ban, CircleCheck, CircleExclamation, CircleInfo, TriangleExclamation } from '@enterprise/ui';

import type { OutcomePresentation } from './types/outcome-presentation.type';

const outcomeMap: Record<NotificationOutcome, OutcomePresentation> = {
  cancelled: {
    color: '#6A6E78',
    icon: Ban,
    label: 'Cancelled',
  },
  completed: {
    color: '#38A169',
    icon: CircleCheck,
    label: 'Completed',
  },
  failed: {
    color: '#E53E3E',
    icon: CircleExclamation,
    label: 'Error',
  },
  info: {
    color: '#3182CE',
    icon: CircleInfo,
    label: 'Info',
  },
  running: {
    color: '#805AD5',
    icon: ArrowsRotate,
    label: 'Running',
  },
  timedout: {
    color: '#ED8936',
    icon: TriangleExclamation,
    label: 'Timed out',
  },
};

export const outcomePresentation = (outcome: NotificationOutcome): OutcomePresentation => {
  return outcomeMap[outcome];
};
